var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.application = OCS.BootFunctions.application || {};

OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};

OCS.WxBriefing.Classes.AboutManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'AboutManager',
    is_open: false,
    options: {
        activate_button_id: 'about_btn',
        html_template_id: 'about_window_template',
        event_namespace: ".about_manager_event",
        about_window_title: 'About This Version',
        popup_ops: {
            popup_box_styles: {
                'background': '#393f4f'
            },
            popup_content_styles: {
                'background': '#393f4f'
            },
            popup_template_close: '<div class="{{popup_close_container_class}}"><div class="{{popup_title_class}}">{{popup_title_text}}</div><div class="{{popup_close_button_class}}"></div></div>'
        }
    },
    init: function (op) {
        this.setOptions(op);
        if (OCS.Constants.DEBUG) {
            console.log('OCS.WxBriefing.Live.UI.AboutManager initialized');
        }

        OCS.Functions.get_ajax_manager();
        var em = OCS.WxBriefing.Functions.get_event_manager();
        if (this.events.about_click) {
            em.unsubscribe(this.events.about_click);
        }
        this.events.about_click = em.subscribe({'event_name': "click", "callback": this.handle_btn.bind(this), selector: 'header .settings_menu  .' + this.options.activate_button_id, "specific_event": true, "prevent_default": true});

    },
    handle_btn: function () {
        if (!this.is_open) {
            this.open();
        } else {
            this.close();
        }
    },
    open: function () {
        if (!this.popup_container) {
            var container = document.id(this.options.html_template_id);
            if (container) {
                this.popup_container = container;
            } else {
                this.popup_container = new Element('div', {
                    "id": this.options.html_template_id
                }).inject(document.body);
            }
        }
        var popup = new OCS.WxBriefing.Classes.PanelPopup(this.popup_container, this.options.popup_ops);
        popup.set_popup_data(this.draw());
        popup.open_form();
        popup.set_title(this.options.about_window_title);
        this.is_open = true;
        //OCS.WxBriefing.Functions.get_event_manager().publish('send_ga_event', {'category': 'About', 'action': "open"});
    },
    close: function () {
        var popup = new OCS.WxBriefing.Classes.PanelPopup(this.popup_container, this.options.popup_ops);
        popup.close_form();
        this.is_open = false;
    },
    draw: function () {
        return Elements.from(OCS.WxBriefing.Functions.get_template_manager().get_html(this.options.html_template_id, {'version': OCS.Version}));
    },
    destroy: function () {
        if (this.popup_container) {
            this.close();
        }
        this.remove_registered_events();
    }
});